import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-releasenotes',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './releasenotes.component.html',
  styleUrl: './releasenotes.component.css'
})
export class ReleasenotesComponent {

}
